<template class="align-items-stretch">
    <div class="content-wrapper container">
        <h1 class="show-title text-center">
            Home to Your Jewellery's Authenticity
        </h1>

        <div class="row show wallet">
            <div class="col-md-8">
                <div class="show-content">
                    <h2>TESSA</h2>
                    <p>
                        Digital experience and authenticity certificate for your jewellry
                    </p>
                    <a :href="tessaLink"><button class="btn">Access My Wallet</button></a>
                </div>
            </div>
            <div class="col-md-4 background-wrapper">
                <img class="background" src="/images/show-wallet.png" alt="wallet" />
            </div>
        </div>

        <div class="row show reporting">
            <div class="col-md-8 order-md-2">
                <div class="show-content">
                    <h2>PROFESSIONAL</h2>
                    <p>Production reporting and tracability</p>
                    <a href="/login">
                        <button class="btn">Access My Reporting</button>
                    </a>
                </div>
            </div>
            <div class="col-md-4 order-md-1 background-wrapper">
                <img class="background" src="/images/show-professional.png" alt="reporting" />
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";

export default {
  components: {},
  props: {
    tessaLink: {
      type: String,
      default: ""
    }
  },
  data() {
    return {};
  },
  computed: {},
  mounted() {},
  methods: {}
};
</script>

<style scoped lang="scss">
.content-wrapper {
  margin-top: 125px !important;
}

@media (max-width: 992px) {
  .content-wrapper {
    margin-top: 85px !important;
  }
}

@media (max-width: 768px) {
  .content-wrapper {
    margin-top: 55px !important;
  }
}

.show-title {
  margin: 25px 0 50px 0;
  font-weight: bold;
  font-size: 25px;
}

@media (max-width: 768px) {
  .show-title {
    font-size: 19px;
    margin: 5px 0 20px 0;
  }
}

.show {
  color: white;
}

@media (max-width: 768px) {
  .show {
    margin: auto;
    width: 75%;
    margin-bottom: 25px;
  }
}

@media (max-width: 575px) {
  .show {
    width: 85%;
    margin-bottom: 15px;
  }
}

.show.wallet {
  background-color: #ffbd59;
}

.show.wallet .btn {
  background-color: white;
  color: black;
}

.show.reporting {
  background-color: #102647;
}

.show.reporting .btn {
  background-color: #9cb9d1;
  color: white;
}

.show-content {
  text-align: center;
  width: fit-content;
}

@media (min-width: 768px) {
  .show-content {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
@media (max-width: 768px) {
  .show-content {
    padding: 10px;
  }
}

.show-content h2 {
  font-weight: bold;
  margin-bottom: 12px;
}

@media (max-width: 768px) {
  .show-content h2 {
    margin-top: 0px;
  }
}

.show-content p {
  font-size: 17px;
}

.show-content .btn {
  margin-top: 15px;
  border-radius: 5px;
  font-weight: bold;
  font-size: 15px;
}

@media (max-width: 768px) {
  .show-content .btn {
    margin-top: 0px;
  }
}

.background-wrapper {
  padding: unset;
}

.background {
  width: 100%;
  height: 250px;
  object-fit: cover;
}
</style>
